import type { ConversationPlan } from '@knownow/domain'

/**
 * Returns true when a plan has any user-authored content worth confirming
 * before deletion: information needs, a saved strategy, or a non-empty
 * description / share token. New empty plans return false so they delete
 * silently.
 *
 * Designer chat history is not included here — it isn't surfaced on the plan
 * list, and a plan with chat but no other config is unusual enough that a
 * silent delete is acceptable for now.
 */
export function isPlanConfigured(plan: ConversationPlan): boolean {
  if (plan.informationNeeds.length > 0) return true
  if (plan.strategy !== null) return true
  if (plan.description.trim().length > 0) return true
  if (plan.shareToken !== null) return true
  return false
}
